import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// Captions are STICKY: each stays until the next line begins. Author ~5-6s apart.
//
// GROUNDING — every claim maps to real EAKC-MVP code (see metadata.md):
//   src/lib/guardrails/pii-detector.ts        (the detector: patterns, Luhn, isLikelySSN, redact)
//   src/lib/guardrails/index.ts               (applyContextGuardrails / applyOutputGuardrails)
//   src/app/api/v1/chat/completions/route.ts  (WHERE: context ~L2077, output ~L2684, try/catch)
//   src/lib/eval/red-team.ts                  (PII-001/PII-002 adversarial leak tests)

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.4, holdSec: 5, caption: "A document in my knowledge base had a real email and an SSN in it." },
  { scene: "hook", fromSec: 5.6, holdSec: 5, caption: "When the AI retrieves that chunk, the raw secret would land in the model's prompt — and in the answer." },
];

export const PROBLEM: ScriptLine[] = [
  { scene: "problem", fromSec: 0.4, holdSec: 5.5, caption: "RAG feeds the model whatever it retrieves. If a source has PII, the model sees it verbatim." },
  { scene: "problem", fromSec: 6.2, holdSec: 5.5, caption: "So I added a guardrail that scrubs PII out of the text — no extra LLM call, just regex." },
];

export const DETECTOR: ScriptLine[] = [
  { scene: "detector", fromSec: 0.4, holdSec: 5.5, caption: "detectPII scans for seven types by default: email, phone, SSN, credit card, IPv4, API keys, AWS keys." },
  { scene: "detector", fromSec: 6.2, holdSec: 5.5, caption: "Pure regex — the comment says it runs in under a millisecond on a typical chunk." },
  { scene: "detector", fromSec: 12, holdSec: 5.5, caption: "Date-of-birth has a pattern too, but it's deliberately left OUT of the default set." },
];

export const VALIDATE: ScriptLine[] = [
  { scene: "validate", fromSec: 0.4, holdSec: 5.5, caption: "Regex alone over-flags. So each risky type gets a second check before it counts as a match." },
  { scene: "validate", fromSec: 6.2, holdSec: 5.5, caption: "Credit cards must pass a Luhn checksum. SSNs reject impossible area codes — 000, 666, 900+." },
  { scene: "validate", fromSec: 12, holdSec: 5.5, caption: "Short phone numbers are dropped, and overlapping matches are de-duplicated." },
];

export const WHERE: ScriptLine[] = [
  { scene: "where", fromSec: 0.4, holdSec: 5.5, caption: "Where does it actually run? Two places in the chat route — verified, not assumed." },
  { scene: "where", fromSec: 6.2, holdSec: 5.5, caption: "applyContextGuardrails redacts the retrieved chunks BEFORE they're sent to the LLM." },
  { scene: "where", fromSec: 12, holdSec: 5.5, caption: "applyOutputGuardrails redacts the LLM's reply BEFORE it's returned to you." },
];

export const REDACT: ScriptLine[] = [
  { scene: "redact", fromSec: 0.4, holdSec: 5.5, caption: "Default strategy is mask: every match becomes [REDACTED]. The secret is just gone." },
  { scene: "redact", fromSec: 6.2, holdSec: 5.5, caption: "There's also a partial mode that keeps the last 4 digits — j***@***.com, ***-**-1234." },
];

export const HONEST: ScriptLine[] = [
  { scene: "honest", fromSec: 0.4, holdSec: 5.5, caption: "Honesty check: it's regex, not magic. Novel formats it can't pattern-match will slip through." },
  { scene: "honest", fromSec: 6.2, holdSec: 5.5, caption: "And the guardrail runs in a try/catch — if it throws, it fails OPEN and logs a warning." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 5, caption: "It's a fast first line of defence: known PII never reaches the model — or the answer." },
  { scene: "outro", fromSec: 5.6, holdSec: 4, caption: "A red-team eval suite checks the system doesn't leak PII even when asked directly." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
